
doulaeasy.iOS = /iPad|iPhone|iPod/.test(navigator.platform);